import { render, staticRenderFns } from "./ControlIngresos.vue?vue&type=template&id=669a943b&"
import script from "./ControlIngresos.vue?vue&type=script&lang=js&"
export * from "./ControlIngresos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports